module.exports = __webpack_public_path__ + "img/plus-blue.917b59ac.svg";